<app-g-store *ngIf="english"></app-g-store>
<app-g-store-hindi *ngIf="hindi"></app-g-store-hindi>